import { render, staticRenderFns } from "./createClientForm.vue?vue&type=template&id=4a97d4f4&"
import script from "./createClientForm.vue?vue&type=script&lang=js&"
export * from "./createClientForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports